;(function () {
  'use strict'

  angular
    .module('admin.mini_game_configurations.service', [])
    .factory('MiniGameConfigurationsService', MiniGameConfigurationsService)

  /** @ngInject */
  function MiniGameConfigurationsService($http, $q, API) {
    function list() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/mini_game_configurations')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listPublish(start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/mini_game_configurations/published?start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function listUnpublish(start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/mini_game_configurations/unpublished?start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function listArchived(start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL + 'admin/mini_game_configurations/expired?start=' + start + '&limit=' + limit,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/mini_game_configurations/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(model) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'admin/mini_game_configurations', model).success(defered.resolve)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/mini_game_configurations/' + id, model)
        .success(defered.resolve)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/mini_game_configurations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      list: list,
      listPublish: listPublish,
      listUnpublish: listUnpublish,
      listArchived: listArchived,
      get: get,
      save: save,
      update: update,
      remove: remove,
    }
  }
})()
